import ApiService from '../../Services/ApiService';
import { getRequest, postRequest } from '../../Services/HttpService';

export const FORGOT_PASSWORD_ERROR = '[AUTH] FORGOT_PASSWORD_ERROR';
export const FORGOT_PASSWORD_SUCCESS = '[AUTH] FORGOT_PASSWORD_SUCCESS';

const URL_FORGOT_PASSWORD = 'v1/auth/forgot-password';
const URL_REGENERATE_ACTIVATION_TOKEN = '/v1/auth/regenerate-activation-token';

const AuthActions = {
  async getForm(language: string): Promise<Record<string, any> | false> {
    const response = await getRequest<Record<string, any>>(
      `${URL_FORGOT_PASSWORD}?language=${language}`
    );
    return response;
  },

  async submitForm(email: string, language: string): Promise<any> {
    const response = await postRequest<{ email: string; language: string }, Record<string, any>>(
      URL_FORGOT_PASSWORD,
      { email, language },
      {
        showToaster: false,
        showErrorToaster: false,
        noAuthHeader: true,
        returnAxiosResponse: true,
        returnAxiosError: true,
      }
    );
    if (response && response.status === 200) {
      return response.data;
    }
    if (response && response.status === 401) {
      return response.data;
    }
    return false;
  },

  async submitFormForExpiredToken(
    email: string,
    resetPasswordToken: string,
    language: string
  ): Promise<any> {
    const response = await ApiService.post(
      `${URL_REGENERATE_ACTIVATION_TOKEN}/${resetPasswordToken}?language=${language}`,
      { email }
    );
    if (response && response.data) {
      return response.data;
    }
    return false;
  },
};

export default AuthActions;
